import { IFlags } from 'flagsmith/types';

import { Flags } from './flags';

export const defaultFlags: IFlags<Flags> = {
  [Flags.SELLER_CORE_SIGNUP_DISABLED]: { enabled: true, id: 0, value: null },
};
